import { Box } from '@mui/material';
import React, { CSSProperties } from 'react';

export function tabProps(tabIdentifier: string, index: number) {
  return {
    id: `${tabIdentifier}-tab-${index}`,
    'aria-controls': `${tabIdentifier}-tabpanel-${index}`,
  };
}
interface TabPanelProps {
  children?: React.ReactNode;
  tabIdentifier: string;
  index: number;
  value: number;
  style?: CSSProperties;
}

const TabPanel = (props: TabPanelProps) => {
  const { tabIdentifier, children, value, index, style } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`${tabIdentifier}-tabpanel-${index}`}
      aria-labelledby={`${tabIdentifier}-tab-${index}`}
      style={style}
    >
      {value === index && <Box>{children}</Box>}
    </div>
  );
};

export default TabPanel;
